import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../store/slices/employeeSlice";

export default function useWizardCommaConvert() {
  const dispatch = useDispatch();
  const { employees } = useSelector((state) => state.employees);

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const Email = localStorage.getItem("email");
  const loggedEmp = employees?.find((emp) => emp?.EmpEmail === Email);
  const countryCode = loggedEmp?.countrycode;

  const formatNumber = (num) => {
    if (num === undefined || num === null) return "";
    const value = Number(num);
    if (isNaN(value)) return "";

    if (countryCode === "+1") {
      return Math.round(value).toLocaleString("en-US");
    }
    if (countryCode === "+91") {
      return Math.round(value).toLocaleString("en-IN");
    }

    return Math.round(value).toLocaleString("en-US");
  };

  return formatNumber;
}
